export default __webpack_public_path__ + "static/icecream-health-2-mobile-f52a63c0f5f42b1ee02780f27c330e10.png";